<template>
    <div>
        <div class="holder">
            <h2 id="page-header"><router-link to="/">My Arlington -</router-link><router-link to="/childcareprograms"> Child Care Availability</router-link></h2>
            <div id="blurb">
              <p>
                  These are the most up-to-date listings of child care in Arlington. Open spots may be prioritized for first responders and other essential workers. Contact providers for details.
              </p>
              <br/>
            </div>
        </div>
        <div class="layer-page">
            <div class="widget one-third filter-pane">
                <div class="filter-header" id="mobile-menu" v-show="isMobile || mobileMenu === false" @click="mobileMenu = !mobileMenu">
                    Filters and Location
                    <svg v-show="!mobileMenu" style="float: right" class="icon"><use xlink:href="#icon-plus"></use></svg>
                    <svg v-show="mobileMenu" style="float: right" class="icon"><use xlink:href="#icon-minus"></use></svg>
                </div>
                <div id="filters-and-settings" v-show="!isMobile || mobileMenu">
                    <div class="filter-container">
                        <div class="filter-header" @click="filtersToggle" v-show="!isMobile" >
                            <span>Filters
                                <svg v-show="filtersExpanded" style="float: right" class="icon"><use xlink:href="#icon-minus"></use></svg>
                                <svg v-show="!filtersExpanded" style="float: right" class="icon"><use xlink:href="#icon-plus"></use></svg>
                                <div style="clear: both"></div>
                            </span>
                        </div>
                        <div class="filterList" v-show="filtersExpanded || mobileMenu"><br/>
                            <div class="filter-item filter-category">Child Care Availability</div>
                            <div class="filter-item">
                                <input v-model="typeSelected" :value="'ChildCare'" type="checkbox" />
                                <span class="tooltip"> Child Care Center
                                  <span class='box red'></span>
                                </span>
                            </div>
                            <div class="filter-item">
                                <input v-model="typeSelected" :value="'FamilyCare'" type="checkbox" />
                                <span class="tooltip"> Family Day Care
                                  <span class='box blue'></span>
                                </span>
                            </div><br />

                            <div class="filter-item filter-category">Program Status</div>
                            <div class="filter-item">
                                <input v-model="typeSelected" :value="'Status-Open'" type="checkbox" />
                                <span class="tooltip"> Open</span>
                            </div>
                            <div class="filter-item">
                                <input v-model="typeSelected" :value="'Status-Closed'" type="checkbox" />
                                <span class="tooltip"> Closed</span>
                            </div>
                            <div class="filter-item">
                                <input v-model="typeSelected" :value="'Available-Slots'" type="checkbox" />
                                <span class="tooltip"> Available slots</span>
                            </div><br />

                            <div class="filter-item filter-category">Language</div>
                            <div class="language-grouping">
                              <div class="filter-item">
                                  <input v-model="languageSelected" :value="'amha'" type="checkbox" />
                                  <span class="tooltip"> Amharic</span>
                              </div>
                              <div class="filter-item">
                                  <input v-model="languageSelected" :value="'arab'" type="checkbox" />
                                  <span class="tooltip"> Arabic</span>
                              </div>
                              <div class="filter-item">
                                  <input v-model="languageSelected" :value="'beng'" type="checkbox" />
                                  <span class="tooltip"> Bengali</span>
                              </div>
                              <div class="filter-item">
                                  <input v-model="languageSelected" :value="'engl'" type="checkbox" />
                                  <span class="tooltip"> English</span>
                              </div>
                              <div class="filter-item">
                                  <input v-model="languageSelected" :value="'fars'" type="checkbox" />
                                  <span class="tooltip"> Farsi</span>
                              </div>
                              <div class="filter-item">
                                  <input v-model="languageSelected" :value="'fren'" type="checkbox" />
                                  <span class="tooltip"> French</span>
                              </div>
                              <div class="filter-item">
                                  <input v-model="languageSelected" :value="'hind'" type="checkbox" />
                                  <span class="tooltip"> Hindi</span>
                              </div>
                              <div class="filter-item">
                                  <input v-model="languageSelected" :value="'limi'" type="checkbox" />
                                  <span class="tooltip"> Limi</span>
                              </div>
                              <div class="filter-item">
                                  <input v-model="languageSelected" :value="'othe'" type="checkbox" />
                                  <span class="tooltip"> Other</span>
                              </div>
                              <div class="filter-item">
                                  <input v-model="languageSelected" :value="'punj'" type="checkbox" />
                                  <span class="tooltip"> Punjabi</span>
                              </div>
                              <div class="filter-item">
                                  <input v-model="languageSelected" :value="'span'" type="checkbox" />
                                  <span class="tooltip"> Spanish</span>
                              </div>
                              <div class="filter-item">
                                  <input v-model="languageSelected" :value="'tigr'" type="checkbox" />
                                  <span class="tooltip"> Tigre</span>
                              </div>
                              <div class="filter-item">
                                  <input v-model="languageSelected" :value="'urdu'" type="checkbox" />
                                  <span class="tooltip"> Urdu</span>
                              </div>
                            </div><br/><br/>

                            <div class="filter-item filter-category" style="padding-top: 15px;">Other</div>
                            <div class="filter-item">
                                <input v-model="typeSelected" :value="'AcceptChildCareSubsidy'" type="checkbox" />
                                <span class="tooltip"> Participates in Child Care Subsidy
                                </span>
                            </div>
                            <div class="filter-item">
                                <input v-model="typeSelected" :value="'AcceptVirginiaQuality'" type="checkbox" />
                                <span class="tooltip"> Participates in Virginia Quality
                                </span>
                            </div><br />

                            <div class="filter-container zoom-container">
                                <input v-model="searchProvider" placeholder="Search By Provider" type="text" />
                                <!-- <span class="tooltip"> Open</span> -->
                            </div>

                        </div>
                    </div>

                    <h3>Zoom to Location</h3>
                    <div class="filter-container zoom-container">
                        <label for="addressSearch">Address</label>
                        <br/>
                        <gmap-autocomplete ref="autocomplete" @place_changed="placeChanged"></gmap-autocomplete>
                    </div>

                    <div class="filter-container">
                      <button class="link filter-header" @click="clearAll">Clear All</button>
                    </div>
                </div>
            </div>
            <div class="widget full-map-pane toggle-window">
                <div style="position: relative; top: 0">
                  <h3 class="toggle-bar">
                    <a :class="showMap === true ? 'toggle-link' : 'toggle-link active'" @click="showMap = true">Map</a>
                    <a :class="showMap === false ? 'toggle-link' : 'toggle-link active'" @click="showMap = false" id="list-link">List</a>
                  </h3>
                </div>
                <gmap-map
                    v-show="showMap"
                    :center="mapCenter"
                    :zoom="zoomLevel"
                    :options="mapStyles"
                    id="vue-map-container"
                    >
                    <gmap-marker v-for="item in filteredItems"
                      :key="item.name"
                      :position="item"
                      :icon="item.icon"
                      :options="shapeOptions"
                      @click="(e) => shapeClick(item, e)">
                    </gmap-marker>
                    <!-- Common Info Window -->
                    <gmap-info-window
                      :opened="selectedInfoWindowPosition !== null"
                      :position="selectedInfoWindowPosition"
                      @closeclick="infoWindowCloseClick">
                        <div class="info-window">
                            <h3 class="info-window-header"><b v-html="selectedItem.name"></b></h3>
                            <span>{{selectedItem['Street Address']}}</span><br/>
                            <span>{{selectedItem['Phone Number']}}</span><br/>
                            <span v-if="selectedItem['Website'] && selectedItem['Website'] != 'N/A'"><a target="_blank" :href="selectedItem['Website']">Website</a><br/></span>
                            <br/>
                            <span v-if="selectedItem['contact'] && selectedItem['contact'] != 'N/A'"><b>Contact Person:</b> {{selectedItem['contact']}}<br/></span>
                            <span v-if="selectedItem['Program Status\r\nOpen/Closed'] && selectedItem['Program Status\r\nOpen/Closed'] != 'N/A'"><b>Program Status:</b> {{selectedItem['Program Status\r\nOpen/Closed']}}<br/></span>
                            <span v-if="selectedItem['# of Current \r\nAvailable Slots'] && selectedItem['# of Current \r\nAvailable Slots'] != 'N/A'"><b># of Available Slots:</b> {{selectedItem['# of Current \r\nAvailable Slots']}}<br/></span>
                            <span v-if="selectedItem['Age(s) of \r\nAvailable Slots'] && selectedItem['Age(s) of \r\nAvailable Slots'] != 'N/A'"><b>Age(s): of Available Slots</b> {{selectedItem['Age(s) of \r\nAvailable Slots']}}<br/></span>
                            <span v-if="selectedItem['Accepts Child Care Subsidy'] && selectedItem['Accepts Child Care Subsidy'] != 'N/A'"><b>Participates in Child Care Subsidy:</b> {{selectedItem['Accepts Child Care Subsidy'] == 0 ? 'No' : 'Yes' }}<br/></span>
                            <span v-if="selectedItem['Language'] && selectedItem['Language'] != 'N/A'"><b>Language:</b> {{selectedItem['Language']}}<br/></span>
                            <span v-if="selectedItem['Participates in Virginia Quality'] && selectedItem['Participates in Virginia Quality'] != 'N/A'"><b>Participates in Virginia Quality:</b> {{selectedItem['Participates in Virginia Quality']}}<br/></span>
                            <span v-if="selectedItem['Notes'] && selectedItem['Notes'] != 'N/A'"><b>Notes:</b> {{selectedItem['Notes']}}<br/></span>
                        </div>
                    </gmap-info-window>

                    <!-- Location Markers -->
                    <gmap-marker v-if="selectedCoordinates" :position="selectedCoordinates" :radius="24"></gmap-marker>
                    <gmap-polygon v-if="civicAssocationsSelected" :path="civicAssocationsSelected.paths" :options="locationOptions"></gmap-polygon>
                    <GmapCircle v-if="selectedCoordinates && radiusSelected" :center="selectedCoordinates" :radius="radiusSelected*1609" :visible="true" :options="{fillColor:'blue',fillOpacity:0.1,strokeWeight:0.7,strokeColor:'blue'}"></GmapCircle>
                </gmap-map>
                <div v-show="!showMap" class="list-pane">
                  <div v-for="item in filteredItems" :key="item.Facility" class="project">
                    <div>
                      <div class="row">
                        <h3 class="h3-list"><b v-html="item.name"></b></h3>
                      </div>
                        <p class="no-vertical-margin">
                            <span>{{item['Street Address']}}</span>
                            <span v-if="item['Phone Number']"><br/>{{item['Phone Number']}}</span><br/>
                            <span v-if="item['Website'] && item['Website'] != 'N/A'"> <a target="_blank" :href="item['Website']">Website</a><br/></span>
                        </p><br/>
                        <p class="no-vertical-margin">
                        <span v-if="item['contact'] && item['contact'] != 'N/A'"><b>Contact Person:</b> {{item['contact']}}<br/></span>
                        <span v-if="item['Program Status\r\nOpen/Closed'] && item['Program Status\r\nOpen/Closed'] != 'N/A'"><b>Program Status:</b> {{item['Program Status\r\nOpen/Closed']}}<br/></span>
                        <span v-if="item['# of Current \r\nAvailable Slots'] && item['# of Current \r\nAvailable Slots'] != 'N/A'"><b># of Available Slots:</b> {{item['# of Current \r\nAvailable Slots']}}<br/></span>
                        <span v-if="item['Age(s) of \r\nAvailable Slots'] && item['Age(s) of \r\nAvailable Slots'] != 'N/A'"><b>Age(s) of Available Slots:</b> {{item['Age(s) of \r\nAvailable Slots']}}<br/></span>
                        <span v-if="item['Accepts Child Care Subsidy'] && item['Accepts Child Care Subsidy'] != 'N/A'"><b>Participates in Child Care Subsidy:</b> {{item['Accepts Child Care Subsidy'] == 0 ? 'No' : 'Yes' }}<br/></span>
                        <span v-if="item['Language'] && item['Language'] != 'N/A'"><b>Language:</b> {{item['Language']}}<br/></span>
                        <span v-if="item['Participates in Virginia Quality'] && item['Participates in Virginia Quality'] != 'N/A'"><b>Participates in Virginia Quality:</b> {{item['Participates in Virginia Quality']}}<br/></span>
                        <span v-if="item['Notes'] && item['Notes'] != 'N/A'"><b>Notes:</b> {{item['Notes']}}<br/></span>
                        </p>
                    </div>
                  </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import R from 'ramda';
import Vue from 'vue';
import * as VueGoogleMaps from 'vue2-google-maps'
import { mapGetters, mapActions } from 'vuex';

Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyDIkJCuWTcYkqhKmKQBKgsFvLJYeZxUu4U',
    libraries: 'places'
  }
})

export default {
  name: 'childCarePrograms',
  data () {
    return {
      isMobile: false,
      showMap: true,
      mobileMenu: null,
      filtersExpanded: true,
      mapStyles: {styles: [{featureType: 'poi', elementType: 'labels', stylers: [{ visibility: 'off' }]}]},
      civicAssocationsSelected: '',
      civicAssociationFailure: false,
      // map properties
      center: {
        lat: 38.8809462,
        lng: -77.099029
      },
      radiusSelected: '',
      icon: {
        path: 'M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z',
        fillColor: '#0040FF', // '#015cb9',
        fillOpacity: 1,
        strokeWeight: 0.5,
        strokeColor: '#fff',
        scale: 1,
        anchor: { x: 14, y: 10 } // eslint-disable-line no-undef
      },
      shapeOptions: {
        strokeColor: '#0040FF',
        strokeOpacity: 0.9,
        strokeWeight: 4,
        fillColor: '#0040FF',
        fillOpacity: 0.35,
        zIndex: 2
      },
      locationOptions: {
        strokeColor: '#FF0000',
        strokeOpacity: 0.9,
        fillColor: '#FF0000',
        fillOpacity: 0.35,
        zIndex: 1
      },
      addressPinOptions: {
        strokeColor: '#FF0000',
        strokeOpacity: 0.9,
        fillColor: '#FF0000',
        fillOpacity: 0.9
      },
      childCareProgramsIcon: {},
      familyDayCareProgramsIcon: {},
      selectedCoordinates: null,
      selectedInfoWindowPosition: null,
      selectedItem: {},
      searchText: '',
      typeSelected: [],
      languageSelected: [],
      searchProvider: ''
    }
  },
  computed: {
    ...mapGetters(['childCarePrograms', 'familyDayCarePrograms']),
    zoomLevel: function () {
      if (!this.selectedCoordinates && !this.civicAssocationsSelected) {
        return 13;
      }
      return 15;
    },
    mapCenter: function () {
      if (this.selectedCoordinates) {
        return this.selectedCoordinates;
      }

      return this.center;
    },

    test: function (item) {
      return item > 10;
    },
    filteredItems: function () {
      let _ccp = this.childCarePrograms
      _ccp = _ccp.map(obj => ({ ...obj, icon: this.childCareProgramsIcon }))
      let _fdcp = this.familyDayCarePrograms
      _fdcp = _fdcp.map(obj => ({ ...obj, icon: this.familyDayCareProgramsIcon }))

      let _tp = _ccp.concat(_fdcp);

      if (this.typeSelected && this.typeSelected.length > 0) {
        if (this.typeSelected.includes('FamilyCare') && this.typeSelected.includes('ChildCare')) {
          // no filter
        } else if (this.typeSelected.includes('FamilyCare')) {
          _tp = _tp.filter(f => f['type'] === 'FamilyCare')
        } else if (this.typeSelected.includes('ChildCare')) {
          _tp = _tp.filter(f => f['type'] === 'ChildCare')
        }
        if (this.typeSelected.includes('Status-Open')) {
          _tp = _tp.filter(f => f['Program Status\r\nOpen/Closed'] === 'Open')
        }
        if (this.typeSelected.includes('Status-Closed')) {
          _tp = _tp.filter(f => f['Program Status\r\nOpen/Closed'] === 'Closed')
        }
        if (this.typeSelected.includes('Available-Slots')) {
          _tp = _tp.filter(f => /\d/.test(f['# of Current \r\nAvailable Slots']) && (f['# of Current \r\nAvailable Slots'] > 0))
        }
        if (this.typeSelected.includes('AcceptChildCareSubsidy')) {
          _tp = _tp.filter(f => f['Accepts Child Care Subsidy'] && f['Accepts Child Care Subsidy'].toLowerCase() === 'yes')
        }
        if (this.typeSelected.includes('AcceptVirginiaQuality')) {
          _tp = _tp.filter(f => f['Participates in Virginia Quality'] && f['Participates in Virginia Quality'].toLowerCase() === 'yes')
        }
      }

      if (this.languageSelected.length > 0) {
        _tp = _tp.filter(f => {
          if (f['Language']) {
            let languages = f['Language'].split(',')
            let languageSelected = this.languageSelected.toString()

            return languages.some(e => {
              return languageSelected.includes(e.toString())
            })
          }
          return false
        })
      }

      if (this.searchProvider.length > 0) {
        _tp = _tp.filter(f => {
          return f.name && f.name.toLowerCase().includes(this.searchProvider.toLowerCase())
        })
      }

      return _tp
    }
  },
  mounted: function () {
    this.loadChildCarePrograms();
    this.loadFamilyDayCarePrograms();

    this.childCareProgramsIcon = {...this.icon};
    this.childCareProgramsIcon.fillColor = '#ff0000'; // blue

    this.familyDayCareProgramsIcon = {...this.icon};
    this.familyDayCareProgramsIcon.fillColor = '#0040FF'; // blue

    this.isMobile = window.innerWidth < 600;
  },
  watch: {
    statusesSelected () {
      this.infoWindowCheck();
    },
    projectTypesSelected () {
      this.infoWindowCheck();
    }
  },
  methods: {
    ...mapActions(['loadChildCarePrograms', 'loadFamilyDayCarePrograms']),
    filtersToggle: function () {
      this.filtersExpanded = !this.filtersExpanded
    },
    clearAll () {
      this.typeSelected = [];
      this.languageSelected = [];
      this.searchProvider = '';
      this.statusesSelected = [];
      this.projectTypesSelected = [];
      this.selectedCoordinates = null;
      this.civicAssocationsSelected = '';
      this.$refs.autocomplete.$refs.input.value = '';
      this.radiusSelected = '';
    },
    placeChanged: function (place) {
      this.selectedCoordinates = { lat: place.geometry.location.lat(), lng: place.geometry.location.lng() };
    },
    setLocation: function (lat, lng) {
      this.selectedCoordinates = { lat: lat, lng: lng };
    },
    getCurrentLocation: function () {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(pos => {
          this.selectedCoordinates = { lat: pos.coords.latitude, lng: pos.coords.longitude };
        }, err => {
          alert('Unable to determine current location at this time.');
          return err;
        });
      }
    },
    shapeClick: function (item, clickEvent) {
      this.selectedItem = item;
      this.selectedInfoWindowPosition = clickEvent.latLng;
    },
    infoWindowCloseClick: function () {
      this.selectedItem = {};
      this.selectedInfoWindowPosition = null;
    },
    infoWindowCheck () {
      if (this.selectedItem && this.selectedItem.id) {
        const ifCheck = R.find(p => p.id === this.selectedItem.id)(this.filteredProjects);
        if (ifCheck === null || ifCheck === undefined) {
          this.selectedItem = {};
          this.selectedInfoWindowPosition = null;
        }
      }
    },
    parentStatusClick (parentStatus) {
      var statusValues = R.map(R.prop('value'), parentStatus.subStatuses);
      statusValues.forEach(s => {
        const i = this.subStatusesSelected.indexOf(s.value);
        if (i >= 0) {
          this.subStatusesSelected.splice(i, 1);
        }
      });
    }
  }
}

</script>

<style lang="scss" scoped>
    .filter-category {
      clear: both;
      font-weight: bold;
      font-size: 1.45em;
    }

    .toggle-link {
      cursor: pointer;
      padding: 0 12px;
  color: #e87c1a;
    }

    .active {
      color: #015cb9;
    }

    .toggle-window {
      border: 2px solid #f1f1f1;
      padding: 8px;
      margin-bottom: 4px;
    }

    #list-link {
      border-left: 2px solid #f1f1f1;
    }

    .toggle-bar {
      padding-bottom: 8px;
      border-bottom: 2px solid #f1f1f1;
    }

    p.no-vertical-margin {
      margin-bottom: 0;
      margin-top: 0;
    }

    .project {
      margin-bottom: 1rem;
    }

.list-pane {
  overflow-y: scroll;
}

.operations-list {
  li {
    font-size: 1em;
    padding: 0px;
  }
}

.h3-list {
  margin: 0px;
}

.column {
  float: left;
  width: 50%;
  min-width: 145px;
  min-height: 55px;
}

.info-window-header {
  margin: 0px;
}

.info-window-body {
  clear: both;
}

.header-column-left {
  float: left;
  width: 75%;
  min-height: 30px;
}

.header-column-right {
  float: left;
  width: 25%;
  min-width: 15px;
  min-height: 30px;
  margin-bottom: 3px;
  height: auto;
  span {
    font-size: 20px;
  }
}

.list-header-column-left {
  float: left;
  width: 75%;
  min-height: 25px;
}

.list-header-column-right {
  float: left;
  width: 25%;
  min-width: 15px;
  min-height: 25px;
  margin-bottom: 1px;
  height: auto;
  span {
    font-size: 20px;
    margin-top: 6px;
  }
}

.row:after {
  display: table;
  clear: both;
}

.transit-row {
  font-size: 20px;
}

.filter-item-nested {
  margin-left: 10px;
}

#zoom-header {
  padding-top: 15px;
  clear: both;
}

.language-grouping {
  .filter-item {
    width: 50%;
    float: left;
  }
}

.box {
  float: right;
  height: 16px;
  width: 16px;
  margin-left: 5px;
  margin-right: 5px;
  margin-top: 3px;
  border: 1px solid black;
  clear: both;
}

.red {
  background-color: #ff0000;
}

.blue {
  background-color: #0040FF;
}

@media (max-width: 650px) {
  .list-pane {
    max-height: 80%;
  }
}
</style>



// WEBPACK FOOTER //
// childCarePrograms.vue?14308ca2